import React, { useContext, useState } from "react";
import Permiso from "../../router/Permiso";
import ListadoConsolidado from "./ListadoConsolidado";
import ListadoDetallada from "./ListadoDetallada";
import ListadoMarcacion from "./ListadoMarcacion";
import { AuthContext } from "../../context/AuthContext";

const AsistenciaAdmin = () => {
    const { token } = useContext(AuthContext);
    const [tab, setTab] = useState("listado");
    const [refreshTrigger] = useState(0);

    const renderTab = () => {
        switch (tab) {
            case "listado":
                return <ListadoConsolidado token={token} refreshTrigger={refreshTrigger} />;
            case "detallado":
                return <ListadoDetallada token={token} refreshTrigger={refreshTrigger} />;
            case "marcacion":
                return <ListadoMarcacion token={token} refreshTrigger={refreshTrigger} />;
            default:
                return null;
        }
    };

    return (
        <div className="ventas-admin-content">
            <div className="ventas-admin-header">
                <div className="ventas-admin-header-row">
                    <div>
                        <div className="ventas-admin-title">Asistencia</div>
                        <div className="ventas-admin-subtitle">
                            Generar reporte detallados con filtros avanzados
                        </div>
                    </div>
                </div>
                <div className="ventas-admin-tabs">
                    <button
                        className={tab === "listado" ? "active" : ""}
                        onClick={() => setTab("listado")}
                    >
                        Consolidado
                    </button>

                    <Permiso permiso="menu_asistencia">
                        <button
                            className={tab === "detallado" ? "active" : ""}
                            onClick={() => setTab("detallado")}
                        >
                            Detallada
                        </button>
                    </Permiso>
                    <Permiso permiso="menu_asistencia">
                        <button
                            className={tab === "marcacion" ? "active" : ""}
                            onClick={() => setTab("marcacion")}
                        >
                            Marcación
                        </button>
                    </Permiso>
                </div>
            </div>
            <div className="ventas-admin-tab-content">{renderTab()}</div>
        </div>
    );
};

export default AsistenciaAdmin;
